import { Table } from "rsuite";

export const CustomTableHeaderCells = (props: any) => (
  <Table.HeaderCell {...props} style={{ padding: 4 }} />
);
